module.exports = __webpack_public_path__ + "img/white_circel.863f8f8f.svg";